import { useLocation } from 'react-router';
import { useNavigate } from 'react-router-dom';

import { useOutLinkInfoActions } from '@/store/zustand/store';
import { useEffect } from 'react';
import RouterList from '@/common/route/RouterList';
import Loading from '@/component/mui/Backdrop';

export default function OutLink() {
  const { pathname } = useLocation();
  const { setOutLinkInfo } = useOutLinkInfoActions();
  const navigate = useNavigate();
  const split = pathname.split('@');
  useEffect(() => {

    // URL 파싱 검증
    if (split.length < 6) {
      console.error('잘못된 OutLink URL 형식, split.length:', split.length);
      navigate('/signInSns');
      return;
    }

    const payload = {
      path: split[1],
      toAddr: split[2],
      amount: split[3],
      symbol: split[4].toUpperCase(),
      chain: split[5],
    };

    const type = RouterList().find((item: any) => item.name === payload.path);

    if (type === undefined) {
      navigate('/signInSns');
    } else {
      setOutLinkInfo(payload);
      // 경로 앞에 / 추가
      navigate(`/${payload.path}`, { replace: true });
    }

    return () => {};
  }, [pathname]);

  return (
    <>
      <Loading isLoading={true} />
    </>
  );
}

/**
 * 샘플
 * https://shuffledev1116.hupayx.io/outLink@sendForm@0x1e6c07eab148D896ccf9165b3634657B2db51249@1200000000000000000@TRL@22203
 * url경로@받는주소@수량@심볼@체인아이디
 */
